PerformerPerson.detectReferralId();
WebmasterPerson.detectReferralId();

if (typeof SiteUtils == 'undefined') SiteUtils = function(){};
SiteUtils.initialURL='';
SiteUtils.init = function () {
  SiteUtils.popupHandler();
  SiteUtils.tooltipHandler();
  SiteUtils.formsubmitHandler();
  SiteUtils.customerChatHandler();
  SiteUtils.initialURL = location.href;
  $(()=>
  {
    if (Config.openChatLightbox && SiteUtils.initialURL.indexOf("chat/") != -1) {
      SiteUtils.initialURL = "//" + location.host;
    }
  });
};

SiteUtils.getModal = function () {
  let modalEl = document.getElementById('siteModal');
  if (!modalEl) {
    document.body.insertAdjacentHTML('beforeend', `
      <div class="modal fade" id="siteModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">   
          </div>
        </div>
      </div>
      `);
    modalEl = document.getElementById('siteModal');
  }
  return modalEl;
};

SiteUtils.showPopup = function (el, content) {
  const modalEl = SiteUtils.getModal();
  const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
  const modaContent = modalEl.querySelector('.modal-content');
  const api = {
      set: function(path, value) {
        if (path === 'content.text')
          modaContent.innerHTML = value;
      },
      hide: function() {
        modal.hide();
      },
      destroy: function() {
        modaContent.innerHTML = '';
      }
    };

  if (typeof content === 'function') {
    const result = content(null, api);
    if (result)
      modaContent.innerHTML = result;
  } else {
    modaContent.innerHTML = content;
  }
  modal.show();
  modalEl.addEventListener(
    'hidden.bs.modal',
    function handler() {
      document.querySelectorAll('.tooltip').forEach(el => el.remove());
      modalEl.removeEventListener(
        'hidden.bs.modal',
        handler
      );
      api.destroy();
    }
  );
  return api;
};

if (typeof console == "undefined") window.console = {};
if (typeof console.dir == "undefined") console.dir = function(){};


SiteUtils.removeFromArray = function (arr, val) {
  var newArr = [];
  for(var i = 0; i < arr.length; i++) {
    if (arr[i] != val) newArr[newArr.length] = arr[i];
  }
  return newArr;
};

SiteUtils.popupHandler = function() {
  jQuery(document).on("click",".popup-trigger", function(event){
    event.preventDefault();
    var el = $(this);
    if (el.data("chat-interface") != null && typeof window[el.data("chat-interface")] == "function" ) {
      window[el.data("chat-interface")].call();
      return false;
    }

    var allowCache = !!el.data("nocache");
    SiteUtils.showPopup(el,function(ev, api) {
    if (SiteUtils.initialURL != el.attr('href')) history.pushState({},"",el.attr('href'));
      $.ajax({ url: el.attr('href')+(el.attr('href').indexOf("?")<0?"?":"&")+'ajax=1'+
        (el.attr('href').indexOf('login') > 0 ? '&login_redirect_url='+SiteUtils.initialURL : ""), cache: allowCache })
        .done(function(html) {
          api.set('content.text', html);
          Recaptcha.init(document.querySelector('#siteModal .modal-content'));
          if (typeof datepickerInit != "undefined") datepickerInit();
        })
        .fail(function(xhr, status, error) {
          api.set('content.text', '<p class="error">'+status + ': ' + error+'</p>')
        });
      return '<p class="text-info">Loading...</p>';
      }, event);
  });
};

SiteUtils.helloPacketHandled = false;

SiteUtils.customerChatHandler = function() {
  jQuery(document).on("click.chat", ".customerchat-trigger", function(event) {
    if (!Config.openChatLightbox || Config.mobile) return true;
    event.preventDefault();
  });

  $(function() {
    jQuery(document).off("click.chat", ".customerchat-trigger");
    if (!Config.openChatLightbox || Config.mobile) return true;
    jQuery(document).on("click.chat", ".customerchat-trigger", function (event) {
      //if (!Config.openChatLightbox || Config.mobile) return true;
      event.preventDefault();

      var camchat = CustomerChat.getInstance();
      var camchat_settings = camchat.getSettings();
      var chatCont = $(camchat_settings.container);
      chatCont.find(".panel-video").addClass("noresize");
      if (!SiteUtils.helloPacketHandled) {
        camchat.bind("CustomerHelloPacket", function (packet) {
          $(".lightbox-sn").text(packet.hostName)
        });
        SiteUtils.helloPacketHandled = true;
      }

      var el = $(this);
      //$('.qtip').qtip('destroy');
      $.ajax({
        "url": el.attr("href"),
        "success": function (json, textStatus, xhr) {
          $('.wp-lightbox-chat').addClass("active");
          if (SiteUtils.initialURL != el.attr('href')) history.pushState({},"",el.attr('href'));
          camchat.connect(json);

          var camchatNode = document.getElementById('camchat');
          var listenerDOMSubtreeModified = function () {
            $('#camchat video').on('ended', function (){
              if (ChatUtils.getItem("sound_volume") > 0) $(".btn-sound").trigger("mutechanged", [false]);
              camchatNode.removeEventListener('DOMSubtreeModified', listenerDOMSubtreeModified);
            });
          };
          camchatNode.addEventListener("DOMSubtreeModified", listenerDOMSubtreeModified);
        },
        "error": function (xhr, status, thrown) {
          var resp = xhr.responseText;
          if (status == "parsererror" && resp.indexOf("<div") != -1 && resp.indexOf("<!DOCTYPE") == -1) {
            SiteUtils.showPopup(el, resp, event, null, "site-dialogue");
          }
        },
        dataType: "json",
        "data": {"command": "get-connection-info", "ajax": 1}
      })
    });
  });
  jQuery(document).on("click",".customerchat-close-trigger", function(event){
    event.preventDefault();

    try {
      var camchat = CustomerChat.getInstance(),
        camchat_settings = camchat.getSettings(),
        chatCont = $(camchat_settings.container);
      camchat.disconnect();
      camchat.hideDialog();
    } catch (e) {}
    if (location.href != SiteUtils.initialURL) {
      history.pushState({},"",SiteUtils.initialURL);
    }
    chatCont.removeClass("active");
    $(".lightbox-sn").html("&nbsp;");

    $(".wp-lightbox-chat").removeClass("active");

  });

};

SiteUtils.formsubmitHandler = function(){
  jQuery(document).on("submit",".formsubmit-trigger", function (e) {
      if (!SiteUtils.submitForm(this))
        e.preventDefault();


  });
};

SiteUtils.submitForm = function (frm, isAjax, callback) {
  var form = jQuery(frm);
  if (form.find("[name=ajax]").val()!="true") return true;
  var fData = new FormData(frm);
  //if (!isAjax) return true;
  //fData.append("ajax",true);

 //submit
 jQuery.ajax({
   "url": form.attr("action"),
   "type": form.attr("method"),
   "cache": false,
   //"async": false,
   "data": form.serializeArray(),
   //"contentType": form.attr("enctype"),
   //"contentType": false,
   "dataType": "html",
   //"processData": false,
   "success": function(html, textStatus, jqXHR) {
     html = jQuery.trim(html);
     //return;
     if (html == "<reload/>") {
       document.location.reload();
       return;
     }
     else if(html.indexOf("<reload>") == 0) {
       document.location.href = html.substring(8, html.length - 9);
       return
     }
     else if (html.indexOf("<html") != -1) {
       document.location.reload(true);
       return;
     }
     if ($(form).closest('.qtip').length > 0) {
        $($(form).closest('.qtip')[0]).qtip('api').destroy(true);
     }
     SiteUtils.showPopup($(form),function(ev, api) {
         api.set('content.text',html);
         return html;
       },
       event,"show");
     if (typeof callback != "undefined") callback.call();
   },
   "error": function(html) {
     console.dir(html);
   }
 });
  return false;
};

SiteUtils.tooltipHandler = function () {
  // tooltip-trigger (data-tooltip)
  $(document).on("mouseenter", ".tooltip-trigger", function () {
    let el = this;
    if (bootstrap.Tooltip.getInstance(el)) return;
    new bootstrap.Tooltip(el, {
      title: el.dataset.tooltip,
      html: true,
      trigger: "hover",
      placement: "top",
      container: "body",
    });
    el.dispatchEvent(new Event("mouseenter"));
  });
  // fav-trigger (title attribute)
  $(document).on("mouseenter", ".fav-trigger[title]", function () {
    let el = this;
    if (bootstrap.Tooltip.getInstance(el)) return;
    new bootstrap.Tooltip(el, {
      title: el.getAttribute("title"),
      trigger: "hover",
      placement: "right",
      container: "body",
    });

    el.dispatchEvent(new Event("mouseenter"));
  });
};

SiteUtils.init();